<div class="products-container">
  <!-- Header -->
  <div class="header">
    <!-- Breadcrumbs -->
    <div class="breadcrumbs">
      <!-- Go Back Action -->
      <button class="action-btn secondary-btn icon-btn" (click)="goBack()">
        <span class="icon">
          <img src="assets/icones/arrow-back-black.svg" alt="" />
        </span>
      </button>
      <span>
        <div class="breadcrumb-item">
          {{
            (source === "catalogs" ? "Catalogs.catalogs" : "agent.title")
              | translate
          }}
        </div>
      </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span> {{ catalogId ? ('Catalogs.new_catalog.products.listing.edit_catalog' | translate) : ('Catalogs.new_catalog.products.listing.new_catalog' | translate) }} </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span style="font-weight: 600"> {{ 'Catalogs.new_catalog.products.listing.add_products' | translate }} </span>
    </div>
    <!-- Create Agent Catalog Action -->
    <div>
      <button 
        class="action-btn primary-btn has-icon" 
        *appHasPermission="submitPermission()"
        (click)="setNewCatalogProducts()" 
        [disabled]="selectedProducts.length === 0 || (!areProductsValid && source !== 'agents') || hasInvalidPrices()"
        data-testid="catalog-update-products-btn"
>
        <span class="icon">
          <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
        </span>
        <span>{{ 'Catalogs.new_catalog.products.listing.update_catalog' | translate }}</span>
      </button>
    </div>
  </div>
  <!-- Content -->
  <div class="products-content">
    <!-- Loading screen for initial data fetch in edit mode -->
    <div class="loading-container" *ngIf="catalogId && (!isCatalogDataLoaded || !isCurrenciesLoaded)">
      <div class="loading-content">
        <app-loader></app-loader>
      </div>
    </div>
    
    <!-- Loading overlay for select all process -->
    <div class="select-all-loading-overlay" *ngIf="isSelectingAll" (scroll)="$event.stopPropagation()" (wheel)="$event.preventDefault()">
      <div class="select-all-loading-content">
        <div class="spinner"></div>
        <p class="loading-message">{{ selectingAllMessage || 'Loading...' }}</p>
      </div>
    </div>
    
    <ng-container>
      <app-selecteable-products-list
        *ngIf="isCatalogDataLoaded && isCurrenciesLoaded"
        [products]="products"
        [productsMetadata]="productsMetadata"
        [isLoadingMore]="isLoadingMore"
        [isSelectingAll]="isSelectingAll"
        [hasSelectedAllProducts]="hasSelectedAllProducts"
        [canSubmit]="canSubmit"
        [selectedProductIds]="selectedProductIds"
        [options]="{
          title: 'Catalogs.new_catalog.products.listing.title' | translate,
          triggerPage: 'catalog-edit',
          filterIsActive: isFilterActive()
        }"
        [source]="source"
        (selectedProductsChange)="onSelectedProductsChange($event)"
        (openFilter)="openFilter()"
        (clearFilter)="clearFilter()"
        (loadMore)="loadMore()"
        (areSelectedProductsValidEmitter)="areProductsValidEmitter($event)"
        (searchChange)="onSearchChange($event)"
        (selectAllRequested)="onSelectAllRequested()"
        (deselectAllRequested)="onDeselectAllRequested()"
      ></app-selecteable-products-list>
    </ng-container>
  </div>
</div>
